import React, { Component } from "react";
import "react-moment";
import moment from "moment";
import DashboardRecharts from "./Ventadia";
import DashboardVentasMes from "./VentasMes";
import DashboardVentasHistoricas from "./Ventashistoricas";
import './NuevoDashboard.css';

class NuevoDashboard extends Component {
    constructor(props){
        super(props);
        this.state = {
            TotalVentas: null,
            TotalProductosAgotarStock: null,
            TotalProductosVales: null,
            dataVentasDia: [],
            dataVentasPorMes: [],
            dataVentasPorSemana: [],
            dataMediosPago: [],
            dataSucursales: [],
            
            filtrosVentasDia: {
                fechaBusqueda: moment().format("YYYY-MM-DD"),
                idSucursal: ""
            },
            filtrosVentasMes: {
                idSucursal: ""
            },
            filtrosVentasHistoricas: {
                idSucursal: ""
            },
            
            loadingSections: {
                ventasDia: false,
                ventasMes: false,
                ventasHistoricas: false
            },
            loadedSections: {
                ventasDia: false,
                ventasMes: false,
                ventasHistoricas: false
            }

        };

        this.timeoutRefs = {
            ventasDia: null,
            ventasMes: null,
            ventasHistoricas: null
        };

        this.handleVerVentasTurnosActivosEmpresa = this.handleVerVentasTurnosActivosEmpresa.bind(this);
        this.handleVerProductosAgotarStock = this.handleVerProductosAgotarStock.bind(this);
        this.handleIrProductosMasVendidos = this.handleIrProductosMasVendidos.bind(this);
        this.handleReportesStock = this.handleReportesStock.bind(this);
        this.getSucursales = this.getSucursales.bind(this);
        
        this.handleSucursalChangeDia = this.handleSucursalChangeDia.bind(this);
        this.handleFechaBusquedaChangeDia = this.handleFechaBusquedaChangeDia.bind(this);
        this.handleFiltrarVentasDia = this.handleFiltrarVentasDia.bind(this);
        
        this.handleSucursalChangeMes = this.handleSucursalChangeMes.bind(this);
        this.handleFiltrarVentasMes = this.handleFiltrarVentasMes.bind(this);


    }

    componentDidMount() {
        this.getSucursales();

        const mesNumero = new Date().getMonth();
        this.mesLetras(mesNumero);
    }

    componentWillUnmount() {
        Object.values(this.timeoutRefs).forEach(timeout => {
            if (timeout) clearTimeout(timeout);
        })
    }

    mesLetras = (mesNumero) => {
        const month = [
            "ENERO",
            "FEBRERO",
            "MARZO",
            "ABRIL",
            "MAYO",
            "JUNIO",
            "JULIO",
            "AGOSTO",
            "SETIEMBRE",
            "OCTUBRE",
            "NOVIEMBRE",
            "DICIEMBRE"
        ];
        
        this.setState({
            MesActual: month[mesNumero]
        });
    }

    handleAccordionToggle(section, isExpandig) {
        if (this.timeoutRefs[section]){
            clearTimeout(this.timeoutRefs[section]);
        }

        if (isExpandig && !this.state.loadedSections[section]){
            this.setState(prevState => ({
                loadingSections: {
                    ...prevState.loadingSections,
                    [section]: true
                }
            }));

            this.timeoutRefs[section] = setTimeout(() => {
                this.loadSectionData(section);
            }, 800);
        }
    }

    async loadSectionData(section) {
        try {
            switch (section) {
                case 'ventasDia':
                    await this.getVentasDelDia(
                        this.state.filtrosVentasDia.fechaBusqueda, 
                        this.state.filtrosVentasDia.idSucursal
                    );
                    await this.getMediosPago(
                        this.state.filtrosVentasDia.fechaBusqueda, 
                        this.state.filtrosVentasDia.idSucursal
                    );
                    break;
                case 'ventasMes':
                    const fechaActual = moment().format("YYYY-MM-DD");
                    await this.getVentasPorSemana(
                        fechaActual,
                        this.state.filtrosVentasMes.idSucursal
                    );
                    break;
                case 'ventasHistoricas':
                    const fechaHoy = moment().format("YYYY-MM-DD");
                    await this.getVentasPorMes(
                        fechaHoy,
                        this.state.filtrosVentasHistoricas.idSucursal
                    );
                    break;
                default:
                    break;
            }

            this.setState(prevState => ({
                loadedSections: {
                    ...prevState.loadedSections,
                    [section]: true
                },
                loadingSections: {
                    ...prevState.loadingSections,
                    [section]: false
                }
            }));

        } catch (error) {
            console.error(`Error loading ${section}:`, error);
            this.setState(prevState => ({
                loadingSections: {
                    ...prevState.loadingSections,
                    [section]: false
                }
            }));
        }
    }

    handleSucursalChangeDia = (event) => {
        const idSucursal = event.target.value;
        this.setState(prevState => ({
            filtrosVentasDia: {
                ...prevState.filtrosVentasDia,
                idSucursal: idSucursal
            }
        }), () => {
            if (this.state.loadedSections.ventasDia) {
                this.handleFiltrarVentasDia();
            }
        });
    }

    handleFechaBusquedaChangeDia = (event) => {
        const fechaBusqueda = event.target.value;
        this.setState(prevState => ({
            filtrosVentasDia: {
                ...prevState.filtrosVentasDia,
                fechaBusqueda: fechaBusqueda
            }
        }), () => {
            if (this.state.loadedSections.ventasDia) {
                this.handleFiltrarVentasDia();
            }
        });
    }

    handleFiltrarVentasDia = async () => {
        const { filtrosVentasDia } = this.state;
        this.setState(prevState => ({
            loadingSections: {
                ...prevState.loadingSections,
                ventasDia: true
            }
        }));

        try {
            await this.getVentasDelDia(filtrosVentasDia.fechaBusqueda, filtrosVentasDia.idSucursal);
            await this.getMediosPago(filtrosVentasDia.fechaBusqueda, filtrosVentasDia.idSucursal);
            
            this.setState(prevState => ({
                loadingSections: {
                    ...prevState.loadingSections,
                    ventasDia: false
                }
            }));
        } catch (error) {
            console.error("Error filtrando ventas del día:", error);
            this.setState(prevState => ({
                loadingSections: {
                    ...prevState.loadingSections,
                    ventasDia: false
                }
            }));
        }
    }

    handleSucursalChangeMes = (event) => {
        const idSucursal = event.target.value;
        this.setState(prevState => ({
            filtrosVentasMes: {
                ...prevState.filtrosVentasMes,
                idSucursal: idSucursal
            }
        }), () => {
            if (this.state.loadedSections.ventasMes) {
                this.handleFiltrarVentasMes();
            }
        });
    }

    handleFiltrarVentasMes = async () => {
        const { filtrosVentasMes } = this.state;
        const fechaActual = moment().format("YYYY-MM-DD");
        
        this.setState(prevState => ({
            loadingSections: {
                ...prevState.loadingSections,
                ventasMes: true
            }
        }));

        try {
            await this.getVentasPorSemana(fechaActual, filtrosVentasMes.idSucursal);
            
            this.setState(prevState => ({
                loadingSections: {
                    ...prevState.loadingSections,
                    ventasMes: false
                }
            }));
        } catch (error) {
            console.error("Error filtrando ventas del mes:", error);
            this.setState(prevState => ({
                loadingSections: {
                    ...prevState.loadingSections,
                    ventasMes: false
                }
            }));
        }
    }

    handleSucursalChangeHistoricas = (event) => {
        const idSucursal = event.target.value;
        this.setState(prevState => ({
            filtrosVentasHistoricas: {
                ...prevState.filtrosVentasHistoricas,
                idSucursal: idSucursal
            }
        }), () => {
            if (this.state.loadedSections.ventasHistoricas) {
                this.handleFiltrarVentasHistoricas();
            }
        });
    }

    handleFiltrarVentasHistoricas = async () => {
        const { filtrosVentasHistoricas } = this.state;
        const fechaActual = moment().format("YYYY-MM-DD");
        
        this.setState(prevState => ({
            loadingSections: {
                ...prevState.loadingSections,
                ventasHistoricas: true
            }
        }));

        try {
            await this.getVentasPorMes(fechaActual, filtrosVentasHistoricas.idSucursal);
            
            this.setState(prevState => ({
                loadingSections: {
                    ...prevState.loadingSections,
                    ventasHistoricas: false
                }
            }));
        } catch (error) {
            console.error("Error filtrando ventas del mes:", error);
            this.setState(prevState => ({
                loadingSections: {
                    ...prevState.loadingSections,
                    ventasHistoricas: false
                }
            }));
        }
    }

    async getSucursales() {
        this.setState({loading: true, error: null});
        try {
            const response = await fetch(`/api/configFactElectronica/SucursalEmpresa`);
            const data = await response.json();
            this.setState({
                loading: false, 
                dataSucursales: data
            });
        } catch (error) {
            this.setState({loading: false, error: error});
        }
    }

    getVentasDelDia = async (fecha, idSucursal = "") => {
        try {
            let url = `/api/dashboard/get/ventasDia/${fecha}`;
            if (idSucursal) {
                url += `/${idSucursal}`;
            }
            
            const response = await fetch(url);
            const ReporteVentasDia = await response.json();
            this.setState({
                dataVentasDia: ReporteVentasDia.respuesta || [],
                isLoading: false,
            });

            return ReporteVentasDia;
        } catch (error) {
            this.setState({error, isLoading: false})
        }
    }

    getVentasPorSemana = async (fecha, idSucursal = "") => {
        try {
            let url = `/api/dashboard/get/ventasSemanas/${fecha}`;
            if (idSucursal) {
                url += `/${idSucursal}`;
            }
            
            const response = await fetch(url);
            const ReporteVentasSemana = await response.json();
            this.setState({
                dataVentasPorSemana: ReporteVentasSemana,
                isLoading: false,
            });

            return ReporteVentasSemana;
        }
        catch (error) {
            this.setState({error, isLoading: false})
        }
    }

    getVentasPorMes = async (fecha, idSucursal = "") => {
        try {
            let url = `/api/dashboard/get/ventasMeses/${fecha}`;
            if (idSucursal) {
                url += `/${idSucursal}`;
            }
            
            const response = await fetch(url);
            const ReporteVentasPorMeses = await response.json();
            this.setState({
                dataVentasPorMeses: ReporteVentasPorMeses.respuesta,
                isLoading: false
            });

            return ReporteVentasPorMeses;
        } catch (error) {
            this.setState({error, isLoading: false})
        }
    }

    getMediosPago = async (fecha, idSucursal = "") => {
        try {
            let url = `/api/dashboard/get/ventas-medio-pago/${fecha}`;
            if (idSucursal) {
                url += `/${idSucursal}`;
            }
            
            const response = await fetch(url);
            const ReporteMediosPago = await response.json();
            this.setState({
                dataMediosPago: ReporteMediosPago.respuesta || [],
                isLoading: false
            });

            return ReporteMediosPago;
        }catch (error) {
            this.setState({error, isLoading: false})
        }
    }

    handleVerProductosAgotarStock() {
        this.props.history.push("/dashboard/productosporagotarstock/")
    }

    handleIrProcesarVales() {
        this.props.history.push("/procesarvales/")
    }

    handleVerVentasTurnosActivosEmpresa() {
        this.props.history.push("/dashboard/ventas/turnosactivos/empresa")
    }

    handleIrProductosMasVendidos() {
        this.props.history.push("/dashborad/productosmasvendidos")
    }

    handleReportesStock() {
        this.props.history.push("/dashborad/reportesstock")
    }

    render() {
        const { 
            dataVentasDia, 
            dataVentasPorSemana, 
            MesActual, 
            dataVentasPorMeses, 
            dataMediosPago, 
            dataSucursales,
            filtrosVentasDia,
            filtrosVentasMes,
            filtrosVentasHistoricas,
            loadedSections, 
            loadingSections
        } = this.state;
        
        return (
            <section className="ventas-fpay-section-vh">
                <div className="container-fluid px-md-5">
                    <div className="mb-2 pt-3">
                        <h4 className="mt-2 text-center">REPORTES GENERALES BETA</h4>
                        <div className="accordion pb-5" id="accordionExample">

                            <div className="abed__card-dashboard">
                                <div className="abed__card-header" id="headingOne">
                                    <h2 className="mb-0 text-center">
                                    <button
                                        className="btn"
                                        type="button"
                                        data-toggle="collapse"
                                        data-target="#collapseOne"
                                        aria-expanded="true"
                                        aria-controls="collapseOne"
                                        style={{ width: '100%' }}
                                        onClick={() => this.handleAccordionToggle('ventasDia', true)}
                                    >
                                        VENTAS DEL DIA
                                    </button>
                                    </h2>
                                </div>
                                <div className="collapse show" id="collapseOne" aria-labelledby="headingOne" data-parent="#accordionExample">
                                    <div className="card-body">
                                        {loadingSections.ventasDia ? (
                                            <div className="text-center py-3">
                                                <div className="spinner-border text-primary" role="status">
                                                    <span className="sr-only">Cargando...</span>
                                                </div>
                                                <p className="mt-2">Cargando ventas del día...</p>
                                            </div>
                                        ) : loadedSections.ventasDia && dataVentasDia ? (
                                            <div className="">
                                                <DashboardRecharts 
                                                    dataVentasDia={dataVentasDia}
                                                    dataMediosPago={dataMediosPago}
                                                    dataSucursales={dataSucursales}
                                                    idSucursal={filtrosVentasDia.idSucursal}
                                                    fechaBusqueda={filtrosVentasDia.fechaBusqueda}
                                                    handleSucursalChange={this.handleSucursalChangeDia}
                                                    handleFechaBusquedaChange={this.handleFechaBusquedaChangeDia}
                                                />
                                            </div>
                                        ): (
                                            <div className="text-center py-3 text-muted">
                                                <i className="fas fa-chart-line fa-2x mb-2"></i>
                                                <p>Expande para cargar las ventas del día</p>
                                            </div>
                                        )} 
                                    </div>
                                </div>
                            </div>
                            <div className="abed__card-dashboard">
                                <div className="abed__card-header" id="headingTwo">
                                    <h2 className="mb-0 text-center">
                                    <button
                                        className="btn collapsed"
                                        type="button"
                                        data-toggle="collapse"
                                        data-target="#collapseTwo"
                                        aria-expanded="false"
                                        aria-controls="collapseTwo"
                                        style={{ width: '100%' }}
                                        onClick={() => this.handleAccordionToggle('ventasMes', true)}
                                    >
                                        VENTAS DEL MES {MesActual && `DE ${MesActual}`}
                                    </button>
                                    </h2>
                                </div>
                                <div className="collapse" id="collapseTwo" aria-labelledby="headingTwo" data-parent="#accordionExample">
                                    <div className="card-body">
                                        {loadingSections.ventasMes ? (
                                            <div className="text-center py-3">
                                                <div className="spinner-border text-primary" role="status">
                                                    <span className="sr-only">Cargando...</span>
                                                </div>
                                                <p className="mt-2">Cargando ventas del mes...</p>
                                            </div>
                                        ) : loadedSections.ventasMes && dataVentasPorSemana ? (
                                            <div className="">
                                                <DashboardVentasMes 
                                                  dataVentasPorSemana={dataVentasPorSemana} 
                                                  MesActual={MesActual}
                                                  dataSucursales={dataSucursales}
                                                  idSucursal={filtrosVentasMes.idSucursal}
                                                  handleSucursalChangeMes={this.handleSucursalChangeMes}
                                                />
                                            </div>
                                        ): (
                                            <div className="text-center py-3 text-muted">
                                                <i className="fas fa-chart-bar fa-2x mb-2"></i>
                                                <p>Expande para cargar las ventas del mes</p>
                                            </div>
                                        )} 
                                    </div>
                                </div>
                            </div>
                            <div className="abed__card-dashboard">
                                <div className="abed__card-header" id="headingThree">
                                    <h2 className="mb-0 text-center">
                                    <button
                                        className="btn collapsed"
                                        type="button"
                                        data-toggle="collapse"
                                        data-target="#collapseThree"
                                        aria-expanded="false"
                                        aria-controls="collapseThree"
                                        style={{ width: '100%' }}
                                        onClick={() => this.handleAccordionToggle('ventasHistoricas', true)}
                                    >
                                        VENTAS HISTORICAS
                                    </button>
                                    </h2>
                                </div>
                                <div className="collapse" id="collapseThree" aria-labelledby="headingThree" data-parent="#accordionExample">
                                    <div className="card-body">
                                        {loadingSections.ventasHistoricas ? (
                                            <div className="text-center py-3">
                                                <div className="spinner-border text-primary" role="status">
                                                    <span className="sr-only">Cargando...</span>
                                                </div>
                                                <p className="mt-2">Cargando ventas históricas...</p>
                                            </div>
                                        ) : loadedSections.ventasHistoricas && dataVentasPorMeses ? (
                                            <div className="">
                                                <DashboardVentasHistoricas 
                                                  dataVentasPorMeses={dataVentasPorMeses}
                                                  dataSucursales={dataSucursales}
                                                  idSucursal={filtrosVentasHistoricas.idSucursal}
                                                  handleSucursalChangeHistoricas={this.handleSucursalChangeHistoricas}
                                                />
                                            </div>
                                        ): (
                                            <div className="text-center py-3 text-muted">
                                                <i className="fas fa-chart-area fa-2x mb-2"></i>
                                                <p>Expande para cargar las ventas históricas</p>
                                            </div>
                                        )} 
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <h4 className="d-flex justify-content-center">REPORTES PERSONALIZADOS</h4>
                        <div className="row w-100 m-0 mt-3 d-flex justify-content-center mb-5">
                            <div type="button" className="dashboard__content--item-g col-12 mt-5" title="Haz clic para ver detalles"
                                onClick={this.handleVerVentasTurnosActivosEmpresa}>
                                <div className="d-flex">
                                    <i className="fas fa-cash-register"></i>
                                    <span className="align-self-center">Ventas de los turnos activos</span>
                                </div>
                                <span className="d-flex justify-content-end">
                                    {this.state.TotalVentas &&
                                        "S/ " + this.state.TotalVentas.toLocaleString("en", {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        })}
                                </span>
                            </div>

                            <div type="button" className="dashboard__content--item-d col-12 mt-5" title="Haz click para ver detalles"
                                onClick={this.handleVerProductosAgotarStock}>
                                <div>
                                    <i className="fas fa-boxes"></i>
                                    Productos Agotados o Próximos en Agotar Stock
                                </div>
                                <span className="d-flex justify-content-end">
                                    {this.state.TotalProductosAgotarStock &&
                                        this.state.TotalProductosAgotarStock}
                                </span>
                            </div>
                            <div hidden className="dashboard__content--item-g col-12 mt-5" type="button"
                                title="Haz click para ir a Procesar Vales" onClick={this.handleIrProcesarVales}>
                                <div>
                                    <i className="fas fa-hourglass-end"></i>
                                    Productos Pendientes en Procesar Vales
                                </div>
                                <span className="d-flex justify-content-end"> 
                                    {this.state.TotalProductosVales &&
                                        this.state.TotalProductosVales}
                                </span>
                            </div>

                            <div type="button" className="dashboard__content--item-d col-12 mt-5" title="Haz click para ver detalles"
                                onClick={this.handleIrProductosMasVendidos}>
                                <div>
                                    <i className="fas fa-barcode"></i>
                                    Productos más Vendidos
                                </div>
                            </div>

                            <div type="button" className="dashboard__content--item-g col-12 mt-5" title="Haz click para ver detalles"
                                onClick={this.handleReportesStock}>
                                <div>
                                    <i className="fas fa-boxes"></i>
                                    Reportes de Stocks
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}
export default NuevoDashboard;